// React
import React from 'react'
import PropTypes from 'prop-types'

// Components
import { FreeDesktop } from './Desktop'
import { FreeMobile } from './Mobile'

// Libraries
import { useFormikContext } from 'formik'

// Hooks
import { usePicker } from 'ui/components/Picker/hooks'

// Shared
import moment from 'shared/lib/moment'
import useWindowSize from 'shared/utils/useWindowSize'

export const Free = (props) => {
  const picker = usePicker()
  const form = useFormikContext()
  const { width } = useWindowSize()

  const isMobile = width < 576

  const from = form.values.starts_at ? new Date(form.values.starts_at) : null
  const to = form.values.stops_at ? new Date(form.values.stops_at) : null

  const handleChangePeriod = ({ startsAt, stopsAt }) => {
    const date = moment(startsAt || stopsAt)

    startsAt = moment(startsAt || form.values.starts_at)
    stopsAt = moment(stopsAt || form.values.stops_at)

    if (!form.values.starts_at) {
      startsAt = picker.setDefaultTime({ type: 'start', date })
    }

    if (!form.values.stops_at) {
      stopsAt = picker.setDefaultTime({ type: 'stop', date, defaultStartTime: startsAt })
    }

    if (startsAt.isAfter(stopsAt)) {
      // starts_at is after stops_at, move the stops_at with the same diff as before
      stopsAt.add(startsAt.diff(moment(form.values.starts_at)))
    }

    form.setValues({
      ...form.values,
      starts_at: startsAt.toJSON(),
      stops_at: stopsAt.toJSON()
    })
  }

  const handleFieldBlur = (date, type) => {
    if (!picker.isDaySelectable({ type, date })) {
      date = picker.setDefaultTime({ type, date, forceDefaultTime: type === 'start' })

      form.setValues({
        ...form.values,
        [`${type}s_at`]: date
      })
    }
  }

  const handleChangeStartsAt = (startsAt) => {
    handleChangePeriod({ startsAt })
  }

  const handleChangeStopsAt = (stopsAt) => {
    handleChangePeriod({ stopsAt })
  }

  const handleBlurStartsAt = (date) => {
    handleFieldBlur(date, 'start')
  }

  const handleBlurStopsAt = (date) => {
    handleFieldBlur(date, 'stop')
  }

  const sharedProps = {
    from,
    to,
    onStartChange: handleChangeStartsAt,
    onStopChange: handleChangeStopsAt,
    onStartBlur: handleBlurStartsAt,
    onStopBlur: handleBlurStopsAt,
    // Prop to control the width of the time picker cleanstate
    width: props.inline ? '100%' : undefined
  }

  return isMobile ? <FreeMobile {...props} {...sharedProps} /> : <FreeDesktop {...props} {...sharedProps} />
}

Free.propTypes = {
  setDefaultTime: PropTypes.func,
  isDaySelectable: PropTypes.func,
  inline: PropTypes.bool
}
